import React from 'react'
import styled from 'styled-components'
import {FaEnvelope, FaFacebook, FaInstagram, FaWhatsapp} from 'react-icons/fa'

import {useStaticQuery, graphql} from 'gatsby'
import Img from 'gatsby-image'
import {Band} from '../../components/Band'
import {spacingUnit} from '../../cssConstants/spacing'
import {fontSizeSmall} from '../../cssConstants/typography'
import {colorWine, colorWhite, colorGrayWarm} from '../../cssConstants/colors'

const BandFooter = styled(Band)`
  text-align: center;
  padding-top: ${spacingUnit}rem;
  padding-bottom: ${spacingUnit}rem;
  font-size: ${fontSizeSmall};
  border-top: 2px solid ${colorWine};
  background-color: ${colorGrayWarm};
`

const Element = styled.div`
  color: ${colorWhite};
  text-align: center;
  margin-top: ${spacingUnit}rem;

  a {
    color: inherit;
    font-size: 2.5rem;
    &:not(:last-child) {
      margin-right: ${spacingUnit}rem;
    }
  }
`

const enhance = x => x

export const Footer = () => {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: {eq: "logo-lbt-dark.png"}) {
        childImageSharp {
          fixed(width: 140) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
    }
  `)
  return (
    <React.Fragment>
      <BandFooter>
        <Img
          fixed={data.file.childImageSharp.fixed}
          alt="Le Bon Ton Catering"
          fadeIn={false}
        />
        <Element>
          <a href="mailto: info@lebonton.it">
            <FaEnvelope />
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://wa.me/0039067026889"
          >
            <FaWhatsapp />
          </a>

          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.facebook.com/Le-Bon-Ton-Catering-189012860679"
          >
            <FaFacebook />
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.instagram.com/lebontoncatering/"
          >
            <FaInstagram />
          </a>
        </Element>
        <Element>
          © 2020 LE BON TON CATERING
          <br />
          L&apos;OSPITALITÀ È KOSHER.
          <br />
          <br />
          King David Catering SRL
          <br />
          P.I e C.F 0425148100
        </Element>
      </BandFooter>
    </React.Fragment>
  )
}

Footer.displayName = 'Footer'
Footer.propTypes = {}

export default enhance(Footer)
